export const appInfo = {
  title: "TL"
};
